<div class="paginator" *ngIf="totalPages > 1">
    <!-- Previous button -->
    <button
        class="page-btn nav-btn"
        [disabled]="pageIndex === 1 || loading"
        (click)="onPageChange(pageIndex - 1)"
    >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
    </button>

    <ng-container *ngIf="!loading">
        <!-- First page -->
        <button
            class="page-btn"
            [class.active]="pageIndex === 1"
            (click)="onPageChange(1)"
        >
            1
        </button>

        <!-- Left ellipsis / input -->
        <ng-container *ngIf="showLeftEllipsis">
            <input
                #leftInput
                *ngIf="showLeftInput"
                type="text"
                class="page-input"
                [(ngModel)]="pageInputValue"
                (keydown)="onPageInputKeydown($event)"
                (blur)="closePageInputs()"
                placeholder=""
            />
            <button
                *ngIf="!showLeftInput"
                class="page-btn ellipsis"
                (click)="toggleEllipsisInput('left')"
            >
                ···
            </button>
        </ng-container>

        <!-- Middle pages -->
        <button
            class="page-btn"
            *ngFor="let page of middlePages"
            [class.active]="page === pageIndex"
            (click)="onPageChange(page)"
        >
            {{ page }}
        </button>

        <!-- Right ellipsis / input -->
        <ng-container *ngIf="showRightEllipsis">
            <input
                #rightInput
                *ngIf="showRightInput"
                type="text"
                class="page-input"
                [(ngModel)]="pageInputValue"
                (keydown)="onPageInputKeydown($event)"
                (blur)="closePageInputs()"
                placeholder=""
            />
            <button
                *ngIf="!showRightInput"
                class="page-btn ellipsis"
                (click)="toggleEllipsisInput('right')"
            >
                ···
            </button>
        </ng-container>

        <!-- Last page -->
        <button
            *ngIf="totalPages > 1"
            class="page-btn"
            [class.active]="pageIndex === totalPages"
            (click)="onPageChange(totalPages)"
        >
            {{ totalPages }}
        </button>
    </ng-container>

    <!-- Next button -->
    <button
        class="page-btn nav-btn"
        [disabled]="pageIndex === totalPages || loading"
        (click)="onPageChange(pageIndex + 1)"
    >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
    </button>
</div>
